module.exports = __webpack_public_path__ + "static/media/nox-scr-monitor.a66370ee.svg";